import React from "react"
import { injectIntl } from "react-intl"
import { Redirect } from "react-router-dom"
import "./featureProtectionWrapper.styles.css"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { useEffect, useState } from "react"
import FeatureProtectionWrapperModal from "./featureProtectionWrapperModal.component"
import { Intl } from "../../../state/helpers/IntlProps"
import { ItemDto } from "../../../state/pricing/Item"
import GlobalHelper from "../../GlobalHelper"

type OwnProps = {
    displayModal: boolean
    message: string
    premium: boolean
    redirectToAccount: boolean
    module: string
    protectionRule: boolean
    isProtected: boolean
    clickRedirect: boolean
    accountFeatureKey: string
    shouldRedirectToAccount: boolean
    lockedItem: boolean
    item: ItemDto
    callback: () => void
    onClose: () => void
    onClickProtected: () => void
    intl: Intl
    isProtectedOverride?: boolean
}


const FeatureProtectionWrapperMain = (props: OwnProps) => {
    const [modal, setModal] = useState(<></>)
    const [redirect, setRedirect] = useState(<></>)
    const [redirectToAccount, setRedirectToAccount] = useState(false)
    const accountFeature = props.accountFeatureKey || ""

    const goToMyAccount = () => {
        setRedirectToAccount(true)
    }

    useEffect(() => {
        if (props.displayModal) {
            setModal(<FeatureProtectionWrapperModal
                premium={props.premium}
                message={props.message}
                onClose={props.onClose}
                goToMyAccount={goToMyAccount}
            ></FeatureProtectionWrapperModal>)
            props.callback()
        } else {
            setModal(<></>)
        }
    }, [props.displayModal])


    useEffect(() => {
        if (redirectToAccount) {
            props.onClickProtected()
            setModal(<></>)
            setRedirect(<Redirect to="/my-account?utm_source=restricted" />)
        }
    }, [redirectToAccount])



    const isLocked = () => {
        if (!GlobalHelper.isEnvProduction()) {
            return false
        }

        if (props.isProtectedOverride) {
            return props.isProtectedOverride
        }

        const protectionRule = props.protectionRule ?? AppContext.accountFeatureIsEnabled(accountFeature)

        if (props.accountFeatureKey === "public") {
            return false
        }

        if (props.isProtected && !protectionRule) {
            return true
        }

        return false
    }

    return <>
        {isLocked() ? props.lockedItem : props.item}
        {redirect}
        {modal}
    </>
}

export default injectIntl(FeatureProtectionWrapperMain)


// WEBPACK FOOTER //
// ./src/common/rich-text/feature-protection-wrappers/featureProtectionWrapperMain.component.tsx